import React from 'react';
import '../../App.css';


export default function CommServ(){
    return <h1 className='comm-serve'>COMMUNITY SERVICE</h1>
}